import React, { useState, useEffect } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import axios from 'axios';

// 🚨 TUS IMPORTACIONES REALES
import { isLogin } from './Authentications'; 
import config from '../../config/apiConfig'; 


/**
 * PrivateRoute modificado para manejar:
 * 1. Verificación de Login (isLogin())
 * 2. Verificación de Permiso de Página (API, usando pageCode)
 * 3. Estado de Carga (evita el "pestañazo" de renderizado)
 * * @param {React.Component} component - Referencia al componente a renderizar (ej: VentasNew)
 * @param {string} pageCode - Código del privilegio que se debe verificar en la API (ej: '#3331')
 * @param {object} extraProps - Props adicionales para el componente (ej: { menuActivo: setMenuActivo })
 */
const PrivateRoute = ({ component: Component, pageCode, extraProps, ...rest }) => {
    const history = useHistory();
    // Estado para saber si el usuario tiene el permiso de esta página. null = Pendiente
    const [isAuthorized, setIsAuthorized] = useState(null); 
    // Estado para el control de carga asíncrona. Empezamos en TRUE para BLOQUEAR el renderizado.
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkAuthorization = async () => {
            
            let authorized = false;

            // 1. Verificación de Login SÍNCRONA
            if (!isLogin()) {
                console.warn("Login Fallido o Sesión no Inicializada. Redirigiendo a /login.");
                // Si falla el login, forzamos la redirección a /login en el render final
                authorized = false; 
            } else if (!pageCode) {
                // Si está logeado pero no requiere código de página, conceder acceso
                authorized = true;
            } else {
                // 2. Verificación de Privilegio de API (Solo si el login es TRUE)
                const token = localStorage.getItem('token'); 
                
                if (!token) {
                    // Está logeado (isLogin true), pero el token no está disponible.
                    authorized = false;
                } else {
                    const url = config.api_url + 'usuarios/acceso/';
                    const parametros = { "codigo": pageCode };
                    const axiosConfig = { headers: { 'token': token } }; 

                    try {
                        const resp = await axios.post(url, parametros, axiosConfig);
                        const granted = resp.data.completado && resp.data.acceso;

                        if (granted) {
                            authorized = true;
                        } else {
                            // 🚨 Redirección inmediata si la API deniega el permiso
                            history.push('/restringido');
                            return; // Salimos del useEffect
                        }

                    } catch (error) {
                        console.error("Fallo de API al verificar acceso:", error);
                        // Redirección inmediata si hay fallo de red/servidor
                        history.push('/restringido'); 
                        return; // Salimos del useEffect
                    }
                }
            }

            // 3. Establecer el estado final después de todas las verificaciones (o si hubo redirección, esto no se ejecuta)
            setIsAuthorized(authorized);
            setIsLoading(false);
        };

        checkAuthorization();
    }, [pageCode]); 

    // ----------------------------------------------------------------------
    // CONTROL DE RENDERIZADO
    // ----------------------------------------------------------------------

    // 1. Si está cargando, MUESTRA NADA (null). 
    // Esto es CLAVE para evitar el pestañazo inicial.
    if (isLoading) {
        return null; 
    }
    
    // 2. Si NO está autorizado (y ya terminó de cargar), redirige al login.
    // Esto ocurre si isLogin() fue falso o si faltaba el token.
    if (!isAuthorized) {
        return <Redirect to="/login" />;
    }
    
    // 3. Si SÍ está autorizado, muestra el componente.
    return (
        <Route {...rest} render={props => (
            <Component {...props} {...extraProps} />
        )} />
    );
};

export default PrivateRoute;